import React from "react";
import { Row, Col } from "react-flexbox-grid";
// SCSS
import "./hero.scss";
//Assets
import HeroImage from "../../assets/hero/hero-image1.png";
//Components
import Button from "../ui-components/button/button";
import Typical from "react-typical"


const hero = () => (
  <div className="hero" id="hero">
    <div className="wrapper">
      <Row>
        <Col md={12} lg={6}>
          <div className="hero-info">
            { <h1 className="weight800 font60">Hi,</h1> }
            <p className="weight700 font40">I'm a {" "}

            <Typical
            loop={Infinity}
            wrapper="b"
            steps={[
              "Developer",
              1000,
              "Programmer",
              1000,
              "Designer",
              1000,
              ]}
            />




            </p>
            <p className="font12">
              Hello, Good day I'm Arif. Currently I'm a 12th grade Student also Freelance Programmer and Designer.
            </p>
            <Button label="SEND MESSAGE" target={"contact"} />
          </div>
        </Col>
        <Col md={12} lg={6}>
        {/*
          <div className="hero-image">
            <img src={HeroImage} alt="hero" />
          </div>
          */
        }
          
        </Col>
      </Row>
    </div>
  </div>
);

export default hero;
